/**
 * Reine Helfer fuer ZEO-Chat-Anhaenge (Dateiauswahl, Einfuegen aus der Zwischenablage, Drag&Drop).
 * Ein Chat-Anhang ist KEIN Akten-Dokument -- die Pruefung hier ist nur Komfort, die massgebliche Pruefung (Endung + Magic-Bytes,
 * Groesse, Dateiname) macht der Server.
 */
export const ERLAUBTE_ENDUNGEN = ['pdf', 'png', 'jpg', 'jpeg', 'webp', 'tif', 'tiff', 'txt', 'docx'];
export const ACCEPT = ERLAUBTE_ENDUNGEN.map((e) => `.${e}`).join(',');
export const MAX_BYTES = 15 * 1024 * 1024;
export const MAX_ANZAHL = 8;

export function endung(name) {
  const m = /\.([A-Za-z0-9]+)$/.exec(name || '');
  return m ? m[1].toLowerCase() : '';
}

export function istBild(datei) {
  const e = endung(datei?.name || datei?.name);
  return ['png', 'jpg', 'jpeg', 'webp', 'tif', 'tiff'].includes(e) || (datei?.type || datei?.mime || '').startsWith('image/');
}

export function formatGroesse(bytes) {
  if (!Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}

export function typLabel(datei) {
  const e = endung(datei?.name);
  return (e || (datei?.type || '').split('/').pop() || 'Datei').toUpperCase();
}

/** -> { ok: true } | { ok: false, grund } -- Vorabpruefung im Browser (Server prueft erneut). */
export function pruefeClientDatei(datei) {
  if (!datei) return { ok: false, grund: 'Keine Datei.' };
  if (!ERLAUBTE_ENDUNGEN.includes(endung(datei.name))) return { ok: false, grund: `„${datei.name}“: Dateityp nicht unterstützt (erlaubt: PDF, PNG, JPG, WEBP, TIFF, TXT, DOCX).` };
  if (datei.size > MAX_BYTES) return { ok: false, grund: `„${datei.name}“ ist zu groß (maximal ${MAX_BYTES / (1024 * 1024)} MB).` };
  if (datei.size === 0) return { ok: false, grund: `„${datei.name}“ ist leer.` };
  return { ok: true };
}

function zeitstempel(d = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}${p(d.getSeconds())}`;
}

const MIME_ENDUNG = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp', 'image/tiff': 'tiff', 'application/pdf': 'pdf', 'text/plain': 'txt' };

/** Dateien aus einem Paste-Event (Screenshot/Bild aus der Zwischenablage). Reiner Text liefert [] (normales Einfuegen bleibt). */
export function dateienAusClipboard(clipboardData, jetzt = new Date()) {
  const items = Array.from(clipboardData?.items || []);
  const dateien = [];
  items.forEach((item, i) => {
    if (item.kind !== 'file') return;
    const f = item.getAsFile && item.getAsFile();
    if (!f) return;
    if (f.name && endung(f.name)) { dateien.push(f); return; }
    const e = MIME_ENDUNG[f.type];
    if (!e) return;
    dateien.push(new File([f], `Screenshot-${zeitstempel(jetzt)}${i ? `-${i + 1}` : ''}.${e}`, { type: f.type }));
  });
  return dateien;
}

export function dateienAusDrop(dataTransfer) {
  return Array.from(dataTransfer?.files || []);
}

export function hatDateien(dataTransfer) {
  return Array.from(dataTransfer?.types || []).includes('Files');
}
